import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UserComponentPresenter } from '../user-component.presenter';
import { ArticleComponentsPresenter } from '@admintool/components/presenter/article-components.presenter';
import { ProjectComponentPresenter } from '@project/components/project-component.presenter';
import { UserModel } from '../../model/user.model';
import { UserPermissionService } from '../../service/user-permission.service';

enum ActionType {
  articleNumber,
  favoriteArticles,
  projectOptions,
}

/**
 * Overview of the user settings that can be changed
 */
@Component({
  standalone: false,
  templateUrl: './choice-action-setting.component.html',
})
export class ChoiceActionSettingComponent implements OnInit {
  public readonly types: ActionType[] = [ActionType.articleNumber, ActionType.favoriteArticles, ActionType.projectOptions];

  public actionType: ActionType = ActionType.articleNumber;

  public numberDisabled = false;
  public optionsDisabled: boolean = false;

  constructor(
    private bsModalRef: BsModalRef,
    private _userComponentPresenter: UserComponentPresenter,
    private articleComponentsPresenter: ArticleComponentsPresenter,
    private projectComponentPresenter: ProjectComponentPresenter,
    private userModel: UserModel,
    private userPermissionService: UserPermissionService,
  ) {}

  ngOnInit(): void {
    if (!this.userPermissionService.isNumberMappingsVisible()) {
      this.numberDisabled = true;
      this.actionType = this.types[1];
    }
    this.optionsDisabled = !this.isProjectOptionsAvailable();
  }

  public async onConfirm(): Promise<void> {
    switch (this.actionType) {
      case ActionType.favoriteArticles:
        await this.favoriteArticlesOrder();
        this.close();
        break;
      case ActionType.articleNumber:
        this.editArticleNumberMappingPopup();
        this.close();
        break;
      case ActionType.projectOptions:
        await this.projectOptions();
        this.close();
        break;
    }
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public editArticleNumberMappingPopup() {
    this.articleComponentsPresenter.openEditArticleNumberMappingDialog();
  }

  public favoriteArticlesOrder(): Promise<void> {
    return this._userComponentPresenter.presentFavoriteArticlesOrderComponent();
  }

  public isProjectOptionsAvailable(): boolean {
    return (
      this.userModel.user &&
      this.userModel.user.hasPermissions([
        "LOAD_PROJECT_OPTION_DEFINITIONS",
        "SAVE_PROJECT_OPTION_DEFINITIONS",
      ])
    );
  }

  public projectOptions(): Promise<void> {
    return this.projectComponentPresenter.openUserProjectOptionsPopup();
  }
}
